import PropTypes from 'prop-types'

export default function ValidationMessage({ children, type }) {
  return (
    <div className="tw-custom-uppercase tw-text-sm tw-text-system-grey-400 tw-my-1">
      {
        <>
          <span
            className={`tw-block ${
              type === 'danger'
                ? 'tw-text-danger'
                : type === 'success'
                ? 'tw-text-success'
                : ''
            }`}>
            {children || <>&nbsp;</>}
          </span>
        </>
      }
    </div>
  )
}

ValidationMessage.defaultProps = {
  type: 'default',
}

ValidationMessage.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['danger', 'default', 'success']),
}
